export const FORMULARIO_GLOBAL_QUESTION_TYPES = {
  RESPOSTA_UNICA: 'RespostaUnica',
  MULTIPLA_ESCOLHA: 'MultiplaEscolha',
  TEXTO_PARAGRAFO: 'TextoParagrafo',
  ESCALA_ESTRELAS: 'EscalaEstrelas',
  ESCALA_LIKERT: 'EscalaLikert',
  RESPOSTA_CURTA: 'RespostaCurta',
  NPS: 'Nps',
  SIMNAO: 'SimNao',
  MATRIZ_SELECAO: 'MatrizSelecao',
};

export const QUESTION_OPTION_LIMIT = 10;
export const LIKERT_QUESTION_OPTION_LIMIT = 11;

export const getQuestionOptionLimit = (tipo) =>
  tipo === FORMULARIO_GLOBAL_QUESTION_TYPES.ESCALA_LIKERT
    ? LIKERT_QUESTION_OPTION_LIMIT
    : QUESTION_OPTION_LIMIT;

export const QUESTION_TYPES_WITH_EDITABLE_OPTIONS = [
  FORMULARIO_GLOBAL_QUESTION_TYPES.RESPOSTA_UNICA,
  FORMULARIO_GLOBAL_QUESTION_TYPES.MULTIPLA_ESCOLHA,
  FORMULARIO_GLOBAL_QUESTION_TYPES.ESCALA_ESTRELAS,
  FORMULARIO_GLOBAL_QUESTION_TYPES.ESCALA_LIKERT,
];

export const QUESTION_TYPES_WITH_OPTIONS = [
  ...QUESTION_TYPES_WITH_EDITABLE_OPTIONS,
  FORMULARIO_GLOBAL_QUESTION_TYPES.NPS,
  FORMULARIO_GLOBAL_QUESTION_TYPES.SIMNAO,
];

export const QUESTION_TYPES_WITH_COMMENT = [
  ...Object.values(FORMULARIO_GLOBAL_QUESTION_TYPES),
];

export const QUESTION_TYPES_WITH_OPTION_COMMENT = [
  ...QUESTION_TYPES_WITH_OPTIONS,
];

export const getQuestionTypeOptions = (intl) => [
  {
    id: FORMULARIO_GLOBAL_QUESTION_TYPES.MATRIZ_SELECAO,
    label: intl.formatMessage({ id: 'labelMatrizSelecao' }),
    description: intl.formatMessage({ id: 'msgMatrizSelecaoDescricao' }),
  },
  {
    id: FORMULARIO_GLOBAL_QUESTION_TYPES.RESPOSTA_UNICA,
    label: intl.formatMessage({
      id: 'labelRespostaUnica',
    }),
    description: intl.formatMessage({
      id: 'labelRespostaUnicaDescricao',
    }),
  },
  {
    id: FORMULARIO_GLOBAL_QUESTION_TYPES.MULTIPLA_ESCOLHA,
    label: intl.formatMessage({
      id: 'labelMultiplaEscolha',
    }),
    description: intl.formatMessage({
      id: 'labelMultiplaEscolhaDescricao',
    }),
  },
  {
    id: FORMULARIO_GLOBAL_QUESTION_TYPES.TEXTO_PARAGRAFO,
    label: intl.formatMessage({
      id: 'labelTextoParagrafo',
    }),
    description: intl.formatMessage({
      id: 'labelTextoParagrafoDescricao',
    }),
  },
  {
    id: FORMULARIO_GLOBAL_QUESTION_TYPES.ESCALA_ESTRELAS,
    label: intl.formatMessage({
      id: 'labelEscalaEstrelas',
    }),
    description: intl.formatMessage({
      id: 'labelEscalaEstrelasDescricao',
    }),
  },
  {
    id: FORMULARIO_GLOBAL_QUESTION_TYPES.ESCALA_LIKERT,
    label: intl.formatMessage({
      id: 'labelEscalaLikert',
    }),
    description: intl.formatMessage({
      id: 'labelEscalaLikertDescricao',
    }),
  },
  {
    id: FORMULARIO_GLOBAL_QUESTION_TYPES.RESPOSTA_CURTA,
    label: intl.formatMessage({
      id: 'labelRespostaCurta',
    }),
    description: intl.formatMessage({
      id: 'labelRespostaCurtaDescricao',
    }),
  },
  {
    id: FORMULARIO_GLOBAL_QUESTION_TYPES.NPS,
    label: intl.formatMessage({
      id: 'labelNps',
    }),
    description: intl.formatMessage({
      id: 'labelNpsDescricao',
    }),
  },
  {
    id: FORMULARIO_GLOBAL_QUESTION_TYPES.SIMNAO,
    label: intl.formatMessage({
      id: 'labelSimNao',
    }),
    description: intl.formatMessage({
      id: 'labelSimNaoDescricao',
    }),
  },
];

const createOption = (texto, ordem, valor = ordem) => ({
  id: 0,
  texto,
  titulo: texto,
  valor: String(valor),
  permitirComentario: false,
  comentarioObrigatorio: false,
  ordem,
});

export const createDefaultQuestionOptions = (tipo, intl) => {
  switch (tipo) {
    case FORMULARIO_GLOBAL_QUESTION_TYPES.ESCALA_ESTRELAS:
      return Array.from({ length: 5 }, (_, index) =>
        createOption(String(index + 1), index + 1, index + 1)
      );
    case FORMULARIO_GLOBAL_QUESTION_TYPES.ESCALA_LIKERT:
      return [
        intl.formatMessage({
          id: 'labelDiscordoTotalmente',
        }),
        intl.formatMessage({
          id: 'labelDiscordo',
        }),
        intl.formatMessage({
          id: 'labelNeutro',
        }),
        intl.formatMessage({
          id: 'labelConcordo',
        }),
        intl.formatMessage({
          id: 'labelConcordoTotalmente',
        }),
      ].map((titulo, index) => createOption(titulo, index + 1, index + 1));
    case FORMULARIO_GLOBAL_QUESTION_TYPES.NPS:
      return Array.from({ length: 11 }, (_, index) =>
        createOption(String(index), index + 1, index)
      );
    case FORMULARIO_GLOBAL_QUESTION_TYPES.SIMNAO:
      return [
        createOption(
          intl.formatMessage({
            id: 'labelSim',
          }),
          1,
          1
        ),
        createOption(
          intl.formatMessage({
            id: 'labelNao',
          }),
          2,
          0
        ),
      ];
    case FORMULARIO_GLOBAL_QUESTION_TYPES.RESPOSTA_UNICA:
    case FORMULARIO_GLOBAL_QUESTION_TYPES.MULTIPLA_ESCOLHA:
      return [1, 2].map((ordem) =>
        createOption(
          intl.formatMessage({ id: 'labelOpcaoNumero' }, { numero: ordem }),
          ordem,
          ordem
        )
      );
    default:
      return [];
  }
};

const getAvailableOptionValue = (usedValues, preferredValue = 1) => {
  let nextValue = Math.max(Number(preferredValue) || 1, 1);

  while (usedValues.has(String(nextValue))) {
    nextValue += 1;
  }

  return String(nextValue);
};

export const getNextQuestionOptionValue = (opcoes = []) => {
  const usedValues = new Set(
    opcoes.map((opcao) => String(opcao.valor ?? '').trim()).filter(Boolean)
  );

  return getAvailableOptionValue(usedValues, opcoes.length + 1);
};

export const normalizeQuestionOptions = (opcoes = []) => {
  const usedValues = new Set();

  return opcoes.map((opcao, index) => {
    const storedValue = String(opcao.valor ?? '').trim();
    const preferredValue = storedValue || String(index + 1);
    const valor = usedValues.has(preferredValue)
      ? getAvailableOptionValue(usedValues, index + 1)
      : preferredValue;

    usedValues.add(valor);

    return {
      id: opcao.id || 0,
      texto: opcao.texto ?? '',
      titulo: opcao.titulo ?? '',
      valor,
      permitirComentario: !!opcao.permitirComentario,
      comentarioObrigatorio:
        !!opcao.permitirComentario && !!opcao.comentarioObrigatorio,
      ordem: index + 1,
    };
  });
};

const hasOptionText = (value) => String(value ?? '').trim().length > 0;

const normalizeFixedQuestionOptionLabels = (tipo, opcoes = [], intl) => {
  if (tipo !== FORMULARIO_GLOBAL_QUESTION_TYPES.NPS) return opcoes;

  const defaultOptions = createDefaultQuestionOptions(tipo, intl);

  return opcoes.map((opcao, index) => {
    const valor = String(opcao.valor ?? defaultOptions[index]?.valor ?? index);
    const label = hasOptionText(opcao.titulo)
      ? opcao.titulo
      : hasOptionText(opcao.texto)
      ? opcao.texto
      : valor;

    return {
      ...opcao,
      texto: label,
      titulo: label,
      valor,
    };
  });
};

export const getQuestionOptionsOrDefault = (tipo, opcoes = [], intl) => {
  const hasOptions = QUESTION_TYPES_WITH_OPTIONS.includes(tipo);

  if (!hasOptions) return [];

  return normalizeQuestionOptions(
    normalizeFixedQuestionOptionLabels(
      tipo,
      opcoes.length > 0 ? opcoes : createDefaultQuestionOptions(tipo, intl),
      intl
    )
  );
};

export const normalizeQuestionCommentSettings = (question = {}) => {
  const permitirComentario = !!question.permitirComentario;
  const comentarioObrigatorio =
    permitirComentario && !!question.comentarioObrigatorio;
  const canConfigureOptionComment = QUESTION_TYPES_WITH_OPTION_COMMENT.includes(
    question.tipo
  );

  return {
    ...question,
    permitirComentario,
    comentarioObrigatorio,
    opcoes: (question.opcoes || []).map((opcao) => {
      const optionPermitirComentario =
        permitirComentario &&
        canConfigureOptionComment &&
        !!opcao.permitirComentario;

      return {
        ...opcao,
        permitirComentario: optionPermitirComentario,
        comentarioObrigatorio:
          optionPermitirComentario && !!opcao.comentarioObrigatorio,
      };
    }),
  };
};

const QUESTION_TYPE_ALIASES = {
  1: FORMULARIO_GLOBAL_QUESTION_TYPES.RESPOSTA_CURTA,
  2: FORMULARIO_GLOBAL_QUESTION_TYPES.TEXTO_PARAGRAFO,
  3: FORMULARIO_GLOBAL_QUESTION_TYPES.RESPOSTA_UNICA,
  4: FORMULARIO_GLOBAL_QUESTION_TYPES.MULTIPLA_ESCOLHA,
  5: FORMULARIO_GLOBAL_QUESTION_TYPES.SIMNAO,
  6: FORMULARIO_GLOBAL_QUESTION_TYPES.NPS,
  7: FORMULARIO_GLOBAL_QUESTION_TYPES.ESCALA_ESTRELAS,
  8: FORMULARIO_GLOBAL_QUESTION_TYPES.ESCALA_LIKERT,
  9: FORMULARIO_GLOBAL_QUESTION_TYPES.MATRIZ_SELECAO,
  'resposta-unica': FORMULARIO_GLOBAL_QUESTION_TYPES.RESPOSTA_UNICA,
  SelecaoUnica: FORMULARIO_GLOBAL_QUESTION_TYPES.RESPOSTA_UNICA,
  'multipla-escolha': FORMULARIO_GLOBAL_QUESTION_TYPES.MULTIPLA_ESCOLHA,
  MultiplaSelecao: FORMULARIO_GLOBAL_QUESTION_TYPES.MULTIPLA_ESCOLHA,
  'texto-paragrafo': FORMULARIO_GLOBAL_QUESTION_TYPES.TEXTO_PARAGRAFO,
  Multilinha: FORMULARIO_GLOBAL_QUESTION_TYPES.TEXTO_PARAGRAFO,
  'escala-estrelas': FORMULARIO_GLOBAL_QUESTION_TYPES.ESCALA_ESTRELAS,
  Estrela: FORMULARIO_GLOBAL_QUESTION_TYPES.ESCALA_ESTRELAS,
  'escala-likert': FORMULARIO_GLOBAL_QUESTION_TYPES.ESCALA_LIKERT,
  Likert: FORMULARIO_GLOBAL_QUESTION_TYPES.ESCALA_LIKERT,
  'resposta-curta': FORMULARIO_GLOBAL_QUESTION_TYPES.RESPOSTA_CURTA,
  TextoSimples: FORMULARIO_GLOBAL_QUESTION_TYPES.RESPOSTA_CURTA,
  nps: FORMULARIO_GLOBAL_QUESTION_TYPES.NPS,
  NPS: FORMULARIO_GLOBAL_QUESTION_TYPES.NPS,
  simnao: FORMULARIO_GLOBAL_QUESTION_TYPES.SIMNAO,
  SimNao: FORMULARIO_GLOBAL_QUESTION_TYPES.SIMNAO,
  'sim-nao': FORMULARIO_GLOBAL_QUESTION_TYPES.SIMNAO,
};

export const normalizeFormularioGlobalQuestionType = (tipo) =>
  QUESTION_TYPE_ALIASES[tipo] ||
  tipo ||
  FORMULARIO_GLOBAL_QUESTION_TYPES.RESPOSTA_UNICA;

export const MATRIX_ROW_LIMIT = 10;
export const MATRIX_COLUMN_LIMIT = 10;
export const MATRIX_ITEM_MAX_LENGTH = 1000;

let matrixClientIdCounter = 0;

export const normalizeMatrixItems = (items = []) =>
  items.map((item, index) => {
    matrixClientIdCounter += 1;
    return {
      ...item,
      id: item.id || 0,
      texto: item.texto ?? '',
      ordem: index + 1,
      _formularioGlobalClientId:
        item._formularioGlobalClientId || `matrix-${matrixClientIdCounter}`,
    };
  });

export const normalizeQuestionMatrixSettings = (question) => {
  const nextQuestion = { ...question };

  if (question.tipo !== FORMULARIO_GLOBAL_QUESTION_TYPES.MATRIZ_SELECAO) {
    delete nextQuestion.linhas;
    delete nextQuestion.colunas;
    delete nextQuestion.permitirMultiplaSelecaoPorLinha;
    return nextQuestion;
  }

  return {
    ...nextQuestion,
    linhas: normalizeMatrixItems(question.linhas || []),
    colunas: normalizeMatrixItems(question.colunas || []),
    permitirMultiplaSelecaoPorLinha: !!question.permitirMultiplaSelecaoPorLinha,
  };
};

export const cloneQuestionMatrixSettings = (question) =>
  question.tipo === FORMULARIO_GLOBAL_QUESTION_TYPES.MATRIZ_SELECAO
    ? {
        linhas: normalizeMatrixItems(
          (question.linhas || []).map((item) => ({
            ...item,
            id: 0,
            _formularioGlobalClientId: null,
          }))
        ),
        colunas: normalizeMatrixItems(
          (question.colunas || []).map((item) => ({
            ...item,
            id: 0,
            _formularioGlobalClientId: null,
          }))
        ),
      }
    : {};

const areMatrixItemsEqual = (previous = [], next = []) =>
  previous.length === next.length &&
  previous.every(
    (item, index) =>
      item.id === next[index]?.id &&
      item.texto === next[index]?.texto &&
      item.ordem === next[index]?.ordem &&
      item._formularioGlobalClientId === next[index]?._formularioGlobalClientId
  );

export const areQuestionMatrixSettingsEqual = (previous, next) =>
  previous.permitirMultiplaSelecaoPorLinha ===
    next.permitirMultiplaSelecaoPorLinha &&
  areMatrixItemsEqual(previous.linhas, next.linhas) &&
  areMatrixItemsEqual(previous.colunas, next.colunas);

export const getMatrixInvalidItemIndexes = (items = []) => {
  const texts = items.map((item) => String(item.texto ?? '').trim());
  const normalizedTexts = texts.map((text) => text.toLocaleLowerCase('pt-BR'));
  const textCounts = new Map();
  const invalidIndexes = new Set();

  normalizedTexts.forEach((text) => {
    textCounts.set(text, (textCounts.get(text) || 0) + 1);
  });

  texts.forEach((text, index) => {
    if (
      !text ||
      text.length > MATRIX_ITEM_MAX_LENGTH ||
      textCounts.get(normalizedTexts[index]) > 1
    ) {
      invalidIndexes.add(index);
    }
  });

  return invalidIndexes;
};

export const getQuestionMatrixValidationErrors = (question) => {
  if (question.tipo !== FORMULARIO_GLOBAL_QUESTION_TYPES.MATRIZ_SELECAO)
    return {};

  const errors = {};
  const validateItems = (field, minimum, limit) => {
    const items = question[field] || [];
    if (
      items.length < minimum ||
      items.length > limit ||
      getMatrixInvalidItemIndexes(items).size > 0
    ) {
      errors[field] =
        field === 'linhas'
          ? 'msgMatrizLinhasInvalidas'
          : 'msgMatrizColunasInvalidas';
    }
  };
  validateItems('linhas', 1, MATRIX_ROW_LIMIT);
  validateItems('colunas', 2, MATRIX_COLUMN_LIMIT);
  return errors;
};

export const createFormularioGlobalQuestion = (tipo, ordem, intl) => ({
  id: 0,
  titulo: '',
  tipo: normalizeFormularioGlobalQuestionType(tipo),
  obrigatoria: false,
  permitirComentario: false,
  comentarioObrigatorio: false,
  imagem: null,
  imagemLargura: null,
  imagemAltura: null,
  opcoes: createDefaultQuestionOptions(
    normalizeFormularioGlobalQuestionType(tipo),
    intl
  ),
  ordem,
  ...(normalizeFormularioGlobalQuestionType(tipo) ===
  FORMULARIO_GLOBAL_QUESTION_TYPES.MATRIZ_SELECAO
    ? {
        linhas: normalizeMatrixItems([{ texto: '' }, { texto: '' }]),
        colunas: normalizeMatrixItems([{ texto: '' }, { texto: '' }]),
        permitirMultiplaSelecaoPorLinha: false,
      }
    : {}),
});
